export const useStyles = (theme) => ({
  root: {
    padding: 20,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    fontWeight: "bold",
    borderRadius: 10,
    minHeight: "10vh",
    [theme.breakpoints.down(960)]: {
      padding: 10,
      justifyContent: "center",
    },
  },
});
